'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _socket = require('./socket');

var socket = _interopRequireWildcard(_socket);

var _chats = require('./chats');

var chats = _interopRequireWildcard(_chats);

var _discussions = require('./discussions');

var discussions = _interopRequireWildcard(_discussions);

var _messages = require('./messages');

var messages = _interopRequireWildcard(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 *	Exports all sagas of the application.
 */
exports.default = [socket.watchOpen(), socket.watchDispatchOnOpening(), socket.watchCall(), socket.watchPublish(), socket.watchSubscribe(), chats.watchSocketOpened(), chats.watchAdd(), chats.watchSubscribe(), chats.watchSetActiveDiscussionWorker(), discussions.watchRemoteCreate(), discussions.watchRemoteCreateSuccess(), discussions.watchRemoteUpdate(), discussions.watchRemoteUpdateSuccess(), discussions.watchAdd(), discussions.watchSet(), discussions.watchUpdateWorker(), discussions.watchSubscribe(), messages.watchRemoteCreate(), messages.watchRemoteCreateSuccess(), messages.watchLoadMessagesWorker()];